import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAddCaregiverIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			rx: 16,
			fill: "#F7E4F2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_661_2566)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M28.2861 27.0964L27.7039 27.5692L27.704 27.5692L27.7041 27.5694L27.7046 27.5699L27.7063 27.5721L27.713 27.5803L27.738 27.611L27.8272 27.7202C27.9009 27.8102 28.0001 27.9308 28.101 28.0518C28.201 28.1718 28.3061 28.2964 28.3904 28.3927C28.4315 28.4396 28.4742 28.4872 28.5114 28.526C28.5285 28.5437 28.5555 28.5712 28.5864 28.5985C28.6003 28.6107 28.6308 28.6372 28.6717 28.6649C28.6918 28.6786 28.7298 28.7031 28.7809 28.7268C28.8181 28.744 28.9365 28.797 29.0986 28.797C31.2725 28.797 33.0965 30.2393 33.3082 31.8014C33.3392 32.1477 33.5825 32.3359 33.6543 32.3867C33.7584 32.4605 33.865 32.5027 33.9301 32.5259C34.07 32.5756 34.2338 32.6108 34.3828 32.6375C34.6919 32.6929 35.0863 32.7367 35.4594 32.7705C35.8374 32.8048 36.2134 32.8306 36.4935 32.8477C36.6339 32.8563 36.7511 32.8628 36.8334 32.8672L36.9293 32.8721L36.9551 32.8734L36.9619 32.8737L36.9638 32.8738L36.9643 32.8738L36.9645 32.8738L36.9995 32.1246L36.9646 32.8738L36.982 32.8746H36.9995C38.8233 32.8746 40.2385 32.1025 41.1896 30.8813C42.1233 29.6823 42.5805 28.0929 42.6242 26.4573C42.667 24.8574 42.3703 23.2691 41.4802 22.1323C40.667 21.0937 39.4453 20.539 37.8523 20.5987C37.6846 20.0637 37.3543 19.6208 36.9317 19.2857C36.3278 18.8068 35.5462 18.5514 34.7638 18.4918C33.2267 18.3748 31.3733 19.0119 30.593 20.7338L30.5261 20.8814V21.0434V22.6106C30.5242 23.4216 30.2832 24.2139 29.8333 24.8887C29.3833 25.5637 28.7443 26.091 27.9961 26.4047L27.0728 26.7918L27.7039 27.5691L28.2861 27.0964Z",
					fill: "white",
					stroke: "#A5478C",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.25 20.7499C31.25 17.6433 28.7316 15.125 25.625 15.125C22.5184 15.125 20 17.6433 20 20.7499V22.3749C20 25.4814 22.5184 27.9998 25.625 27.9998C28.7316 27.9998 31.25 25.4814 31.25 22.3749V20.7499Z",
					fill: "white",
					stroke: "#A5478C",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.75 20.7498H30.5",
					stroke: "#A5478C",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6526 28.1248C19.4125 28.1248 18.3258 28.9548 17.9995 30.1512L14.9044 41.4996C14.0803 44.5212 16.355 47.4994 19.487 47.4994H34.4974C36.2608 47.4994 37.5686 45.863 37.1797 44.143L34.0432 30.2684C33.7598 29.0149 32.646 28.1248 31.3609 28.1248H20.6526Z",
					fill: "#ECA8DB",
					stroke: "#A5478C",
					strokeWidth: 1.5,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.0615 32.9995C30.7997 32.9995 29.6997 33.8583 29.3937 35.0825L27.1437 44.0823C26.7098 45.8179 28.0225 47.4992 29.8116 47.4992H41.6269C44.7171 47.4992 46.9845 44.5951 46.235 41.5972L44.6063 35.0825C44.3003 33.8583 43.2003 32.9995 41.9385 32.9995H32.0615Z",
					fill: "#ECA8DB",
					stroke: "#A5478C",
					strokeWidth: 1.5,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 25.625,
					y: 41.8743,
					width: 4.875,
					height: 4.8749,
					fill: "#ECA8DB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.375 35.3745L21.2711 39.79C21.0064 40.8487 21.8072 41.8744 22.8986 41.8744H29.2813C30.8518 41.8744 32.125 43.1475 32.125 44.7181V44.7181C32.125 46.2886 30.8518 47.5618 29.2813 47.5618H25.625",
					stroke: "#A5478C",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsxs("mask", {
					id: "path-9-outside-1_661_2566",
					maskUnits: "userSpaceOnUse",
					x: 31.75,
					y: 25.2498,
					width: 12,
					height: 9,
					fill: "black",
					children: [/* @__PURE__ */ _jsx("rect", {
						fill: "white",
						x: 31.75,
						y: 25.2498,
						width: 12,
						height: 9
					}), /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M41.875 27.2498H33.75C33.75 29.9421 35.5688 32.1247 37.8125 32.1247C40.0562 32.1247 41.875 29.9421 41.875 27.2498Z"
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M41.875 27.2498H33.75C33.75 29.9421 35.5688 32.1247 37.8125 32.1247C40.0562 32.1247 41.875 29.9421 41.875 27.2498Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.75 27.2498V25.7498C32.9216 25.7498 32.25 26.4213 32.25 27.2498H33.75ZM41.875 27.2498H43.375C43.375 26.4213 42.7034 25.7498 41.875 25.7498V27.2498ZM33.75 28.7498H41.875V25.7498H33.75V28.7498ZM32.25 27.2498C32.25 30.5029 34.496 33.6247 37.8125 33.6247V30.6247C36.6417 30.6247 35.25 29.3813 35.25 27.2498H32.25ZM37.8125 33.6247C41.129 33.6247 43.375 30.5029 43.375 27.2498H40.375C40.375 29.3813 38.9833 30.6247 37.8125 30.6247V33.6247Z",
					fill: "#A5478C",
					mask: "url(#path-9-outside-1_661_2566)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.25 41.8753C49.25 45.9483 45.9481 49.2502 41.875 49.2502C37.8019 49.2502 34.5 45.9483 34.5 41.8753C34.5 37.8023 37.8019 34.5005 41.875 34.5005C45.9481 34.5005 49.25 37.8023 49.25 41.8753Z",
			fill: "white",
			stroke: "#A5478C",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.625 41.8752H45.125",
			stroke: "#A5478C",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.875 38.6255V45.1254",
			stroke: "#A5478C",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_661_2566",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 33,
				height: 35,
				fill: "white",
				transform: "translate(14 14)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledAddCaregiverIcon);
const Memo = memo(ForwardRef);
export default Memo;
